class StickyCTA {
  constructor() {
    this.stickySection = document.querySelector('.section.sticky-section');
    this.mainAddToCartButton = null;
    this.isVisible = false;
    this.retryCount = 0;
    this.maxRetries = 50; // 5 seconds max (50 * 100ms)
    this.isInitialized = false;
    
    if (!this.stickySection) {
      return;
    }
    
    this.init();
  }
  
  init() {
    // Find the main add to cart button
    this.findMainAddToCartButton();
  }
  
  findMainAddToCartButton() {
    // Look for the main add to cart button in the product info section
    this.mainAddToCartButton = document.querySelector('.product .product__info-container .product-form__buttons');
    
    // If not found and we haven't exceeded max retries, try again
    if (!this.mainAddToCartButton && this.retryCount < this.maxRetries) {
      this.retryCount++;
      setTimeout(() => {
        this.findMainAddToCartButton();
      }, 100);
      return;
    }
    
    // If we found the button or exceeded retries, initialize scroll handling
    if (this.mainAddToCartButton && !this.isInitialized) {
      this.isInitialized = true;
      this.initScrollHandling();
    }
  }
  
  initScrollHandling() {
    // Add scroll event listener
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    
    // Initial check
    this.handleScroll();
  }
  
  handleScroll() {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    if (!this.mainAddToCartButton || !this.stickySection) {
      return;
    }
    
    const buttonRect = this.mainAddToCartButton.getBoundingClientRect();
    const buttonTop = buttonRect.top;
    
    // Show sticky CTA when the main button is scrolled out of view
    if (buttonTop < headerHeight && !this.isVisible) {
      this.showStickyCTA();
    } else if (buttonTop >= headerHeight && this.isVisible) {
      this.hideStickyCTA();
    }
  }
  
  showStickyCTA() {
    this.stickySection.classList.add('is-visible');
    this.isVisible = true;
  }
  
  hideStickyCTA() {
    this.stickySection.classList.remove('is-visible');
    this.isVisible = false;
  }
}

// Track if we've already initialized to prevent multiple instances
let stickyCTAInstance = null;

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  if (!stickyCTAInstance) {
    stickyCTAInstance = new StickyCTA();
  }
});

// Also initialize on page load for Shopify's dynamic page loading
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('sticky-section') && !stickyCTAInstance) {
    stickyCTAInstance = new StickyCTA();
  }
}); 